import ModalWindow from "../../common/ModalWindow";

const AcceptWorkOrderWindow: React.FC<{
  setShowAcceptWorkOrderWindow: any;
  onAcceptWorkOrder: any;
}> = ({ setShowAcceptWorkOrderWindow, onAcceptWorkOrder }) => {
  const onAcceptWorkOrderOk = async () => {
    await onAcceptWorkOrder();
    setShowAcceptWorkOrderWindow(false);
  };

  const onAcceptWorkOrderCancel = () => {
    setShowAcceptWorkOrderWindow(false);
  };

  return (
    <ModalWindow
      title="Accept Work Order"
      okTitle="Accept"
      onOk={onAcceptWorkOrderOk}
      onCancel={onAcceptWorkOrderCancel}
    >
      <div>
        <div className="mb-2" style={{ fontWeight: "bold" }}>
          Confirm Work Order Acceptance
        </div>
      </div>
    </ModalWindow>
  );
};

export default AcceptWorkOrderWindow;
